/* @ngInject */
function authService (
  $rootScope,
  $location,
  $q,
  $http,
  $cookies,
  ConnectorWebService,
  CONSTANTS,
  Utils,
  IntercomService
) {
  const unallowedSubdomains = [
    'qa',
    'app',
    'localhost'
  ]

  var service = {
    checkIfUserExists,
    getInviteTokenExists,
    getCustomerImages,
    login,
    loginMobile,
    logout,
    validateSsoEnabled,
    setJwtToken,
    setJwtTokenMobile,
    getCompanyBySubdomain,
    validateMFA,
    resendMFA,
    setContainerPosition
  }

  $rootScope.$on('MobileTokenExpired', function (_, data) {
    logout(data)
  })

  return service

  function setJwtTokenMobile (token) {
    $http.defaults.headers.common.Authorization = 'Bearer ' + token

    const fullYear = new Date().getFullYear()
    const expires = new Date().setFullYear(fullYear + 1)

    $cookies.put('jwt', token, { expires: new Date(expires), domain: CONSTANTS.URL_BASE_APP, path: '/', samesite: 'lax', secure: true })
  }

  function loginMobile (userLogin) {
    return ConnectorWebService.post(CONSTANTS.URL_AUTH_LOGIN_MOBILE, userLogin)
      .then(res => {
        if (res.token) {
          setJwtTokenMobile(res.token)
        } else {
          throw new Error('Error when logging in.')
        }
      })
  }

  function setJwtToken (token) {
    const originHostname = document.referrer
    const samesiteProp = defineCookieManagementBasedOnDomain(originHostname)

    $http.defaults.headers.common.Authorization = 'Bearer ' + token
    // 12 hours
    var expirationTime = new Date().getTime() + (12 * 60 * 60 * 1000)
    $cookies.put('jwt', token, { domain: CONSTANTS.URL_BASE_APP, path: '/', expires: new Date(expirationTime), samesite: samesiteProp, secure: true })
  }

  function defineCookieManagementBasedOnDomain (domain) {
    let samesite = 'lax'
    if (!domain) return samesite

    const whitelistDomains = [
      'telemedicinaeinstein.com.br',
      'portalempresas.einstein.br',
      'flickshelf.com'
    ]
    let urlDomain = ''

    try {
      urlDomain = new URL(domain)

      const hostname = urlDomain.hostname

      const isDomainAllowed = whitelistDomains.find(allowedDomain => {
        return hostname === allowedDomain || hostname.endsWith(`.${allowedDomain}`)
      })

      if (isDomainAllowed) {
        samesite = 'none'
      }
    } catch (err) {}

    return samesite
  }

  function login (userLogin) {
    return ConnectorWebService.post(CONSTANTS.URL_AUTH_LOGIN, userLogin)
      .then(res => {
        if (res.token) {
          setJwtToken(res.token)
        } else {
          throw new Error('Error when logging in.')
        }
      })
  }

  function logout (params = {}) {
    const { logoutByClick, errorCode } = params
    let redirectPath = '/login'

    const isGuestUser = $rootScope.oUser && $rootScope.oUser.role === 'GUEST'

    $rootScope.oUser = null
    $rootScope.oUserCompany = null
    $rootScope.companyFeaturesAndAddons = null
    $rootScope.companyWithBillingPackage = null
    $rootScope.oUserCompanyConfigurations = null
    localStorage.removeItem('company')
    IntercomService.shutdown()

    if (Utils.isInReactNativeWebView()) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type: 'LOGOUT' }))
    }

    if (isGuestUser) {
      redirectPath = '/guest/login'
    }

    if (logoutByClick) {
      ConnectorWebService.post(CONSTANTS.URL_AUTH_LOGOUT).then(() => {
        $http.defaults.headers.common.Authorization = ''
        $cookies.remove('jwt', { domain: CONSTANTS.URL_BASE_APP, path: '/' })
        $location.path(redirectPath)
      })
    } else {
      $http.defaults.headers.common.Authorization = ''
      $cookies.remove('jwt', { domain: CONSTANTS.URL_BASE_APP, path: '/' })

      const url = $location.url()
      const isGuestUrl = url.startsWith('/guest')

      if (isGuestUrl) {
        $location
          .path('/guest/login')
          .search({
            next: url
          })
      } else {
        $location
          .path(redirectPath)
          .search({
            next: url,
            showBanner: String(errorCode === 'DUPLICATED_SESSION')
          })
      }
    }
  }

  function validateSsoEnabled (email, subdomain) {
    const body = {
      email
    }

    if (subdomain) {
      body.subdomain = subdomain
    }

    return ConnectorWebService.post(CONSTANTS.URL_AUTH_SSO_VALIDATE, body)
  }

  function checkIfUserExists (email, company) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_CHECK_USER_EXISTS, [email])

    url = Utils.fnAddQueryToUrl(url, { company })

    return ConnectorWebService.get(url)
  }

  function getInviteTokenExists (token) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_INVITE_TOKEN, [token])

    return ConnectorWebService.get(url)
  }

  function getCustomerImages (host) {
    $rootScope.customerColor = '#00abc8'

    const defaultLogo = '/assets/img/logos/customer-logo.webp'
    const defaultBackground = '/assets/img/backgrounds/auth-pages-bg-new.jpg'
    const defaultValues = $q.resolve({
      logo: defaultLogo,
      background: defaultBackground
    })

    const hosts = host.split('.')

    if (!unallowedSubdomains.includes(hosts[0])) {
      const subdomain = hosts[0]

      if (!subdomain) {
        return defaultValues
      }

      const url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_COMPANY_SUBDOMAIN, [subdomain])
      return ConnectorWebService.get(url)
        .then(data => {
          localStorage.setItem('companySubdomain', subdomain)
          const customerColor = data.customerCompanyStrings.find(companyConfig => companyConfig.type === 'COMPANY_PRIMARY_COLOR')
          $rootScope.customerColor = customerColor.value

          const companyLogoUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_COMPANY_SUBDOMAIN_LOGO, [subdomain])
          const companyBackgroundUrl = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_COMPANY_SUBDOMAIN_BACKGROUND, [subdomain])

          return {
            logo: Utils.fnAddQueryToUrl(companyLogoUrl, { date: data.updatedAt }),
            background: Utils.fnAddQueryToUrl(companyBackgroundUrl, { date: data.updatedAt })
          }
        }).catch(() => {
          localStorage.removeItem('companySubdomain')
          return defaultValues
        })
    }

    return defaultValues
  }

  function getCompanyBySubdomain (subdomain) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_EXTERNAL_COMPANY_SUBDOMAIN, [subdomain])

    return ConnectorWebService.get(url)
  }

  function validateMFA (token, verificationCode, password) {
    return ConnectorWebService.post(CONSTANTS.URL_AUTH_MFA_VALIDATE, { token, verificationCode, password })
      .then(res => {
        if (res.token) {
          setJwtToken(res.token)
        }
      })
  }

  function resendMFA (token) {
    return ConnectorWebService.post(CONSTANTS.URL_AUTH_MFA_RESEND, { token })
  }

  function setContainerPosition () {
    const pageHeight = $('.auth-pages-container').height()
    const container = $('.auth-container')
    const containerPadding = 160
    const containerHeight = container.height() + containerPadding

    const margin = (pageHeight - containerHeight) / 2

    container.css('left', margin)
  }
}

export { authService }
